export const theme = {
  colors: {
    cardBgLight: '#ffffff',
    border: '#e0e0e0',
    textOnLight: '#111827',
    primary: '#4F46E5',
    primaryAccent: '#E85D3F',
    buttonTextOnPrimary: '#ffffff',
    muted: '#6B7280',
    hover: '#E5E7EB',
    overlay: 'rgba(0, 0, 0, 0.5)',
    mainBg: '#ffffff',
    text: '#111827',
    error: '#dc2626',
    errorBg: '#fee2e2',
    success: '#16a34a',
    successBg: '#dcfce7',
  },
};